// An area's wash as set on site (#510): its Wash tick and Wash only switch,
// external areas only (pricing-inputs.ts `washIn` decides it the same way).
import { parseSurfaces, washIn } from '@higgins/m2q-pricing';
import type { Fields } from './device-db';

/** The side wash is set on. */
export const WASH_SIDE = 'External';

/** The area's wash as set on site; none when its surfaces can't be read. */
export function siteWash(fields: Fields): { wash: boolean; washOnly: boolean } {
  try {
    return washIn({ fields }, parseSurfaces(typeof fields.hig_surfaces === 'string' ? fields.hig_surfaces : null), undefined);
  } catch {
    return { wash: false, washOnly: false };
  }
}
